import { render } from "./AddLead.vue?vue&type=template&id=78814dfb&scoped=true"
import script from "./AddLead.vue?vue&type=script&lang=js"
export * from "./AddLead.vue?vue&type=script&lang=js"

import "./AddLead.vue?vue&type=style&index=0&id=78814dfb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-78814dfb"

export default script